import { render } from "./SuspiciousActivity.vue?vue&type=template&id=f7cad760&scoped=true"
import script from "./SuspiciousActivity.vue?vue&type=script&lang=js"
export * from "./SuspiciousActivity.vue?vue&type=script&lang=js"

import "./SuspiciousActivity.vue?vue&type=style&index=0&id=f7cad760&scoped=true&lang=scss"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7cad760"]])

export default __exports__